import React from 'react'
import './community.scss'
import { images } from "../../../utils/customFn";
import { Row, Col} from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import  CommonCard from '../../layout/commoncard';
import Data from './data.json';
import FigureCards from '../../layout/figurecards';
import Faq from '../../layout/faqs';
import NewsCard from '../newscards';
const Community = () => {
 
  const revenueData = [
    {
      id: 1,
      value: "1964",
      unit: "Year founded",
      description: "Originally known as the CN Jacobs Foundation, we’re a tax-exempt 501 c(3) independent private foundation.",
    },
    {
      id: 2,
      value: "85",
      unit: "Organizations supported each year",
      description: "To make a meaningful impact, we talk with community leaders to identify and support organizations that are addressing areas of need that align with our giving goals.",
    },
    {
      id: 3,
      value: "4",
      unit: "Primary giving areas",
      description: "Our charitable focus areas are education, workforce development, United Way, and local nonprofits working to improve quality of life in Sentry communities.",
    },
  ];

  const NewsCardData = [
    {
      id: 1,
      title: '2024 Retail & Wholesale Injury Report: Protecting new hires',
      description:
        'Our new report shows higher injury rates among first-year workers in retail and wholesale operations. Dan Grant and Jean Feldman share their tips and insights.',
      linkUrl: '',
      linkText: 'Learn more >',
    },
    {
      id: 2,
      title: 'Sentry employees raise $1.7 million for United Way',
      description:
        'Sentry Insurance employees come together during their annual United Way campaign, raising $1.7 million to support their communities.',
      linkUrl: '/',
      linkText: 'Learn more >',
    },
    {
      id: 3,
      title: 'Innovative optionsDeloitte ranks Sentry No. 13 on Wisconsin 75',
      description:
        'Sentry moved up one spot on the 2024 Wisconsin 75. Its success reflects a long-term growth strategy, forecast to continue in 2025.',
      linkUrl: '/',
      linkText: 'Learn more >',
    },
  ];

  const accordionData = [
    {
      id: 1,
      eventKey: "0",
      header: "What are your giving criteria?",
      body: "We focus our giving efforts on education, workforce development, and local organizations working to improve quality of life and build stronger, more equitable communities where Sentry employees live and work. We don’t give to individuals, political or lobbying organizations, or third-party fundraisers."
    },
    {
      id: 2,
      eventKey: "1",
      header: "Where do you give geographically?",
      body: "We give where our associates live and work. This includes Stevens Point, where Sentry is headquartered, the island of Maui—our home away from home—and the communities where our field offices are located."
    },
    {
        id: 3,
        eventKey: "2",
        header: "Who should I contact for more information?",
        body: "Kalynn Pempek is the Sentry Insurance Foundation Executive Director and can be reached via email at kalynn.pempek@sentry.com or by phone at 715-346-7636."
    }
  ];

  
  return (
    <>
      <div className="community-wrapper">
        <div className="Heading">
          <h2>At Sentry, community engagement isn’t just a corporate goal—it’s our culture</h2>
        </div>
        <div className='mission-banner'>
          <Row className='g-0'>
            <Col sm={12} md={12} lg={6} xl={6}>
              <div className='left-img'>
                <img src={images['mission.avif']} alt="img" />
              </div>
            </Col>
            <Col sm={12} md={12} lg={6} xl={6}>
              <div className='right-details'>
                 <h2>Our Foundation mission</h2>
                 <p>To improve the quality of life and build equitable communities where we live and work, including the Maui community.</p>
                 <NavLink to='#/'>Learn More</NavLink>
              </div>
            </Col>
          </Row>
        </div>
        <CommonCard Title="Areas of giving" CardData={Data} colSizes={{lg: 4, xl: 4 }}/>
        <div className='who-we-are'>
          <h2>Who we are</h2>
          <p>The Sentry Insurance Foundation is the philanthropic arm of Sentry. Giving priorities include education, workforce development, United Way, and local organizations that work to improve the quality of life and build equitable communities where we live and work, including the Maui community—home of the The Sentry.</p>
          <p>At Sentry, charitable giving is an integral part of our business. It’s who we are. And who we’ll always be. We approach our philanthropy the same way we approach our business—through relationships and conversations to understand needs and identify opportunities.</p>
          <p>The Sentry Insurance Foundation provides our employees and retirees with a Matching Gift Program—matching individual donations to eligible charitable organizations, up to $7,500 per year per person. Our associates and retirees are generous, and we’re pleased to help make their gifts go even further to help our communities.</p>
        </div>
        <FigureCards data={revenueData}/>
        <Faq FaqData={accordionData} heading={'FAQs'}/>
        <NewsCard Title="News" CardData={NewsCardData} showNavLink = 'true'/>
        <div className='foundation-info'>
          <Row>
            <Col sm={12} md={6} lg={6} xl={6}>
              <div className='left-logo'>
                <img src={images['sentry-foundation.svg']} alt="logo" />
              </div>
            </Col>
            <Col sm={12} md={6} lg={6} xl={6}>
              <div className='fondation-details'>
                <div className="Heading">
                  <h3>For more foundation information, contact:</h3>
                </div>
                <div className="text">
                  <p>
                    Kalynn Pempek<br />
                    Office: 715-346-7636<br />
                    <a href="mailto:kalynn.pempek@sentry.com" target="_blank" rel="noopener noreferrer">
                      kalynn.pempek@sentry.com
                    </a>
                  </p>
                  <p>
                    For media inquiries, contact:<br />
                    Carolyn Schamberger<br />
                    Office: 715-346-7104<br />
                    <a href="mailto:carolyn.schamberger@sentry.com" target="_blank" rel="noopener noreferrer">
                      carolyn.schamberger@sentry.com
                    </a>
                  </p>
                  <p>
                    Hannah Quick<br />
                    Office: 715-346-7403<br />
                    <a href="mailto:hannah.quick@sentry.com" target="_blank" rel="noopener noreferrer">
                      hannah.quick@sentry.com
                    </a>
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  )
}

export default Community